import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "form layout-column p-md sm:p-0 sm:w-[343px] md:w-[352px]" };
const _hoisted_2 = { class: "typography-display-small mb-md text-center md:text-left" };
const _hoisted_3 = { class: "typography-body-2-regular mb-xl text-center md:text-left" };
const _hoisted_4 = { class: "typography-body-2-bold" };
const _hoisted_5 = { class: "layout-row gap-md items-start" };
import { OrButtonV3, OrIconButtonV3, OrInputV3, useResponsive } from '@onereach/ui-components';
import { onMounted, ref, watch } from 'vue';
import OrLogo from '@/components/OrLogo/OrLogo.vue';
import useI18n from '@/composables/useI18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MFAForm',
    props: {
        username: {},
        isLoading: { type: Boolean },
        error: {},
        verificationCode: {}
    },
    emits: ["toogleOpenRecovery2fa", "logout", "pasteFromBuffer", "submit", "update:verificationCode"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { translate } = useI18n();
        const { isDesktop } = useResponsive();
        const inputError = ref('');
        const submit = () => {
            inputError.value = !props.verificationCode ? translate('login.password_restore.This field is required') : '';
            if (inputError.value)
                return;
            emit('submit');
        };
        watch(() => props.verificationCode, (value) => {
            if ((value === null || value === void 0 ? void 0 : value.length) === 6) {
                submit();
            }
        });
        const twoFactorInput = ref(null);
        onMounted(() => {
            var _a;
            (_a = twoFactorInput.value) === null || _a === void 0 ? void 0 : _a.focus();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(OrLogo, { class: "self-center md:hidden mb-md" }),
                _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(translate)('login.login.twofactorVerification')), 1),
                _createElementVNode("span", _hoisted_3, [
                    _createTextVNode(_toDisplayString(_unref(translate)('login.login.Your profile')) + " ", 1),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.username), 1),
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('login.login.has been configured to use two-factor authentication')), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_unref(OrInputV3), {
                        ref_key: "twoFactorInput",
                        ref: twoFactorInput,
                        "model-value": _ctx.verificationCode,
                        class: "verification-code flex-auto mb-xl",
                        placeholder: _unref(translate)('login.login.Enter Verification Code'),
                        loading: _ctx.isLoading,
                        label: _unref(translate)('login.login.verificationCode'),
                        error: _ctx.error || inputError.value,
                        inputmode: "decimal",
                        autocomplete: "one-time-code",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (emit('update:verificationCode', $event))),
                        onKeyup: _withKeys(submit, ["enter", "native"])
                    }, _createSlots({ _: 2 }, [
                        (!_ctx.isLoading)
                            ? {
                                name: "appendInner",
                                fn: _withCtx(() => [
                                    _createVNode(_unref(OrIconButtonV3), {
                                        tooltip: { content: _ctx.$t('login.login.Paste from clipboard'), placement: 'top' },
                                        size: "l",
                                        icon: "content_paste",
                                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (emit('pasteFromBuffer')), ["stop"]))
                                    }, null, 8, ["tooltip"])
                                ]),
                                key: "0"
                            }
                            : undefined
                    ]), 1032, ["model-value", "placeholder", "loading", "label", "error"])
                ]),
                (_unref(isDesktop))
                    ? (_openBlock(), _createBlock(_unref(OrButtonV3), {
                        key: 0,
                        class: "sign-in md:self-start mb-xl",
                        variant: "link",
                        onClick: _cache[2] || (_cache[2] = ($event) => (emit('toogleOpenRecovery2fa')))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(translate)('login.login.havingProblem')), 1)
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "captcha"),
                (!_unref(isDesktop))
                    ? (_openBlock(), _createBlock(_unref(OrButtonV3), {
                        key: 1,
                        class: "sign-in !p-0 mb-xl",
                        variant: "text",
                        onClick: _cache[3] || (_cache[3] = ($event) => (emit('toogleOpenRecovery2fa')))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(translate)('login.login.havingProblem')), 1)
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                _createVNode(_unref(OrButtonV3), {
                    class: "md:self-start",
                    variant: "link",
                    onClick: _cache[4] || (_cache[4] = ($event) => (emit('logout')))
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(translate)('login.login.Use different email')), 1)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
